import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-remove-fs-assignment-confirm',
  templateUrl: './remove-fs-assignment-confirm.component.html',
  styleUrls: ['./remove-fs-assignment-confirm.component.scss']
})
export class RemoveFsAssignmentConfirmComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<RemoveFsAssignmentConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  noClicked() {
    this.dialogRef.close({status: 'cancelled'});
  }

  yesClicked() {
    this.dialogRef.close({status: 'confirmed'});
  }

}
